import { render, staticRenderFns } from "./BaseMultiselectGroup.vue?vue&type=template&id=52882d8c"
import script from "./BaseMultiselectGroup.vue?vue&type=script&lang=js"
export * from "./BaseMultiselectGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports